import { requestPDServer, handleFetchResponse } from '@/utils/fetchResponse';
import request from '@/api/request';
import Cookies from 'js-cookie';
const baseUrl = process.env.VUE_APP_BASE_API_TALKYTIMES;
const myBaseUrl = process.env.VUE_APP_BASE_API;

// platform/user-conversation-starter/create
// idLast：分页依据；limit：限制数量
//
/**
 * 查询短语列表
 * 参数: {"idLast":0,"limit":15}
 */
export const getConversationStarterList = (data) => {
  return requestPDServer('/platform/user-conversation-starter/list', data);
};
/**
 * 创建新短语
 * 参数: {"description":"水水水水水水"}
 * 返回值: 该短语对应的id
 */
export const createConversationStarter = (data) => {
  return requestPDServer('/platform/user-conversation-starter/create', data);
};

/**
 * 删除短语
 * 参数: {"id":700926}
 * id: 该短语对应的id
 */
export const deleteConversationStarter = (data) => {
  return requestPDServer('/platform/user-conversation-starter/delete', data);
};

/**
 * 最近使用的表情包查询(Recently used)
 * 参数: {"idInterlocutor":104474193,"limit":11}
 * idInterlocutor: 当前聊天的好友id
 * limit: 返回结果限制数量
 */
export const getRecentStickers = (data, options = {}) => {
  return requestPDServer('/platform/chat/stickers/recent', data, options);
};

/**
 * 表情包查询
 * 参数: {"idInterlocutor":104474193}
 * idInterlocutor: 当前聊天的好友id
 */
export const getStickers = (data, options = {}) => {
  return requestPDServer('/platform/chat/stickers', data, options);
};
/**
 * 发送礼物(暂定)
 * 参数: {"idRegularUser":104474193,"idVirtualGift":1154,"vip":false}
 * idRegularUser: 好友id
 * idVirtualGift: 礼物id
 * 返回值: idMessage，该条消息的id
 */
export const sendGift = (data) => {
  return requestPDServer('/platform/chat/send/virtual-gift', data);
};
/**
 * 发送表情包
 * 参数: {"idSticker":1333,"idRegularUser":104474193,"vip":false}
 * idSticker: 表情包id
 * idRegularUser: 好友id
 * 返回值: idMessage，该条消息的id
 */
export const sendSticker = (data) => {
  return requestPDServer('/platform/chat/send/sticker', data);
};

/**
 * 可发送图片查询
 * 参数: {"cursor":"","statuses":["approved","approved_by_ai"],"tags":[],"limit":50,"idAlbum":null,"idAlbumExcluded":null}
 * cursor: 分页依据，初始为空，后续为响应体的cursor字段
 * limit: 返回photos数组长度限制的最大数量
 * tags: 可以为空/special/special_plus
 * statuses: 仅在查询Temporary图片时为空，否则都为["approved","approved_by_ai"]
 * isTemporary：是否查询临时图片，默认不传
 */
export const getGalleryPhotos = async (data) => {
  try {
    // 获取画廊照片列表
    const galleryResponse = await requestPDServer(
      '/platform/gallery/photo/list',
      data
    );

    // 如果galleryResponse中没有photos数组，直接返回原结果
    if (
      !galleryResponse ||
      !galleryResponse.photos ||
      !Array.isArray(galleryResponse.photos)
    ) {
      return galleryResponse;
    }

    // 提取所有照片的idPhoto
    const photoIds = galleryResponse.photos
      .map((photo) => photo.idPhoto)
      .filter((id) => id);

    // 如果没有有效的照片ID，直接返回原结果
    if (photoIds.length === 0) {
      return galleryResponse;
    }

    // 调用getCasualPhotoList获取casual状态
    const casualData = {
      idUser: data.idUser, // 支持两种参数名
      idsPhotos: photoIds,
    };

    const casualResponse = await getCasualPhotoList(casualData);

    // 创建casual状态的映射表
    const casualMap = {};
    if (
      casualResponse &&
      casualResponse.photos &&
      Array.isArray(casualResponse.photos)
    ) {
      casualResponse.photos.forEach((item) => {
        if (item.idPhoto) {
          casualMap[item.idPhoto] = item.status;
        }
      });
    }

    // 将casual状态合并到原照片列表中
    const mergedPhotos = galleryResponse.photos.map((photo) => {
      return {
        ...photo,
        casualStatus: casualMap[photo.idPhoto],
      };
    });

    // 返回合并后的结果
    return {
      ...galleryResponse,
      photos: mergedPhotos,
    };
  } catch (error) {
    console.error('获取画廊照片并合并casual状态时出错:', error);
    // 如果出错，返回原始的gallery响应
    return requestPDServer('/platform/gallery/photo/list', data);
  }
};

/**
 * 可发送视频查询
 * 参数: {"cursor":"","limit":50,"statuses":["approved"],"tags":[],"excludeTags":[]}
 * cursor: 分页依据，初始为空，后续为响应体的cursor字段
 * limit: 返回videos数组长度限制的最大数量
 * tags: 默认为空，取值为["erotic"]时用于在邮件系统中查询Special视频
 */
export const getGalleryVideos = async (data) => {
  try {
    // 获取画廊视频列表
    const galleryResponse = await requestPDServer(
      '/platform/gallery/video/list',
      data
    );

    // 如果galleryResponse中没有videos数组，直接返回原结果
    if (
      !galleryResponse ||
      !galleryResponse.videos ||
      !Array.isArray(galleryResponse.videos)
    ) {
      return galleryResponse;
    }

    // 提取所有视频的idVideo
    const videoIds = galleryResponse.videos
      .map((video) => video.idVideo)
      .filter((id) => id);

    // 如果没有有效的视频ID，直接返回原结果
    if (videoIds.length === 0) {
      return galleryResponse;
    }

    // 调用getCasualVideoList获取casual状态
    const casualData = {
      idUser: data.idUser, // 支持两种参数名
      idsVideos: videoIds,
    };

    const casualResponse = await getCasualVideoList(casualData);

    // 创建casual状态的映射表
    const casualMap = {};
    if (
      casualResponse &&
      casualResponse.videos &&
      Array.isArray(casualResponse.videos)
    ) {
      casualResponse.videos.forEach((item) => {
        if (item.idVideo) {
          casualMap[item.idVideo] = item.status;
        }
      });
    }

    // 将casual状态合并到原视频列表中
    const mergedVideos = galleryResponse.videos.map((video) => ({
      ...video,
      casualStatus: casualMap[video.idVideo],
    }));

    // 返回合并后的结果
    return {
      ...galleryResponse,
      videos: mergedVideos,
    };
  } catch (error) {
    console.error('获取画廊视频并合并casual状态时出错:', error);
    // 如果出错，返回原始的gallery响应
    return requestPDServer('/platform/gallery/video/list', data);
  }
};

/**
 * 可发送语音查询
 * 参数: {"cursor":"","statuses":["approved"],"limit":50}
 * cursor: 分页依据，初始为空，后续为响应体的cursor字段
 * limit: 返回audios数组长度限制的最大数量
 */
export const getGalleryAudios = async (data) => {
  try {
    // 获取画廊音频列表
    const galleryResponse = await requestPDServer(
      '/platform/gallery/audio/list',
      data
    );

    // 如果galleryResponse中没有items数组，直接返回原结果
    if (
      !galleryResponse ||
      !galleryResponse.items ||
      !Array.isArray(galleryResponse.items)
    ) {
      return galleryResponse;
    }

    // 提取所有音频的id
    const audioIds = galleryResponse.items
      .map((audio) => audio.id)
      .filter((id) => id);

    // 如果没有有效的音频ID，直接返回原结果
    if (audioIds.length === 0) {
      return galleryResponse;
    }

    // 调用getCasualAudioList获取casual状态
    const casualData = {
      idUser: data.idUser, // 支持两种参数名
      idsAudios: audioIds,
    };

    const casualResponse = await getCasualAudioList(casualData);

    // 创建casual状态的映射表
    const casualMap = {};
    if (
      casualResponse &&
      casualResponse.data &&
      casualResponse.data.audios &&
      Array.isArray(casualResponse.data.audios)
    ) {
      casualResponse.data.audios.forEach((item) => {
        if (item.idAudio) {
          casualMap[item.idAudio] = item.status;
        }
      });
    }

    // 将casual状态合并到原音频列表中
    const mergedAudios = galleryResponse.items.map((audio) => {
      return {
        ...audio,
        casualStatus: casualMap[audio.id],
      };
    });

    // 返回合并后的结果
    return {
      ...galleryResponse,
      items: mergedAudios,
    };
  } catch (error) {
    console.error('获取画廊音频并合并casual状态时出错:', error);
    // 如果出错，返回原始的gallery响应
    return requestPDServer('/platform/gallery/audio/list', data);
  }
};

/**
 * 发送单张图片
 * 参数: {"idGalleryPhoto":48301700,"idRegularUser":104474193,"vip":false}
 * 返回值: idMessage，该条消息的id
 */
export const sendGalleryPhoto = (data) => {
  return requestPDServer('/platform/chat/send/gallery-photo', data);
};

/**
 * 发送单/多张图片
 * 参数: {"idsGalleryPhotos":[48303645],"idRegularUser":104474193,"vip":false}
 * idsGalleryPhotos: 图片ids
 * idRegularUser: 好友id
 * 返回值: idMessage，该条消息的id
 */
export const sendGalleryPhotos = (data) => {
  return requestPDServer('/platform/chat/send/gallery-photos', data);
};

/**
 * 发送视频(只有单个)
 * 参数: {"idGalleryVideo":7374269,"idRegularUser":104474193,"vip":false}
 * idGalleryVideo: 视频id
 * idRegularUser: 好友id
 * 返回值: idMessage，该条消息的id
 */
export const sendGalleryVideo = (data) => {
  return requestPDServer('/platform/chat/send/gallery-video', data);
};

/**
 * 发送语音（只有单条）
 * 参数: {"idMedia":324771,"idRegularUser":104474193,"vip":false}
 * idMedia: 语音id
 * idRegularUser: 好友id
 * 返回值: idMessage，该条消息的id
 */
export const sendAudio = (data) => {
  if (data && data.idMedia) {
    data.idMedia = Number(data.idMedia);
  }
  return requestPDServer('/platform/chat/send/audio', data);
};

/**
 * 保存输入框数据
 * 参数: {"text":"","idInterlocutor":104474193}
 */
export const saveDraft = (data) => {
  return requestPDServer('/platform/chat/draft/save', data);
};

/**
 * 发送消息（文字和表情）
 * 参数: {"message":"Are you a good dancer?","idRegularUser":104474193,"vip":false}
 * message: 消息内容
 * idRegularUser: 好友id
 * 返回值: idMessage，该条消息的id
 */
export const sendText = (data) => {
  return requestPDServer('/platform/chat/send/text', data);
};

/**
 * 查看post记录
 * 参数: {"idRegularUser":91934905,"idLastPost":0,"limit":15}
 * idRegularUser: 好友id
 * idLastPost: 分页依据，初始为0，后续为上次请求的最后一条响应数据的id
 * limit: 限制返回数据数量
 */
export const getDialogMediaPosts = (data) => {
  return requestPDServer('/platform/chat/dialog/media/posts', data);
};

/**
 * 发送post
 * 参数: {"idRegularUser":104474193,"idsGalleryPhotos":[48644758,48303646,48301700],"idsGalleryVideos":[7374270],"text":"滴滴答答撒大大大大大大顶顶顶顶顶顶顶顶顶顶顶顶顶顶顶顶顶顶顶"}
 * idRegularUser: 好友id
 * idsGalleryPhotos: 发送的图片id集合
 * idsGalleryVideos: 发送的视频id集合
 * text: 发送的文本（100<=length<=3500）
 * 至少四个图片/一个视频/一个视频+任意数量图片
 */
export const sendNewPost = (data) => {
  return requestPDServer('/platform/chat/send/new-post', data);
};

/**
 * 查看post详情
 */
export const getDialogPost = (data) => {
  return requestPDServer('/platform/chat/dialog/post', data);
};
// https://talkytimes.com/platform/correspondence/restriction?idRegularUser=104474193
// {"idRegularUser":104474193}
export const getEmailLimit = (data, options = {}) => {
  return requestPDServer(
    `/platform/correspondence/restriction?idRegularUser=${data.idRegularUser}`,
    {},
    options
  );
};
// https://talkytimes.com/platform/present/thankyou/present/status
// {"idUserTo":104474193}
export const getMessageLimit = (data) => {
  return requestPDServer('/platform/present/thankyou/present/status', data);
};
/**
 * 是否可以发送礼物
 * 参数: {"idUserFrom":69593048,"idUserTo":104474193}
 *
 * https://talkytimes.com/platform/present/thankyou/present/status
 * {"idUserTo":104474193}
 */
export const getGiftStatus = (data) => {
  return requestPDServer('/platform/present/thankyou/present/status', data);
};
// 能否无限制的发送礼物
// 参数：{"idUserFrom":103100046,"idUserTo":123705355}
// 返回：{"limit":0,"canSendWithoutLimit":false}
export const getGiftLimit = (data, options = {}) => {
  return requestPDServer('/platform/virtual-gift/limit/get', data, options);
};

/**
 * 礼物列表
 * 参数: {"limit":30,"cursor":"","idRegularUser":104474193}
 */
export const getGiftList = (data, options = {}) => {
  return requestPDServer('/platform/virtual-gift/gift/list', data, options);
};

/**
 * 获取聊天列表
 * 参数: {"criteria":[],"cursor":"","limit":15}
 * cursor: 分页依据,初始为"",返回的响应体的cursor值（时间）作为下次请求的cursor
 * criteria: 取值为active、bookmarked、vip、unanswered、空，分别对应页面列表中的Active、Saved、VIP、No answer、All chats
 */
export const getChatDialogsByCriteria = (data) => {
  return requestPDServer('/platform/chat/dialogs/by-criteria', data);
};

/**
 * 查找好友
 * 参数: {"idsRegularUser":[104474193,91934905]}
 * 支持多值查询
 * hasNewMessage: true表明有未读消息，false表明没有
 */
export const getChatDialogsByPairs = (data, options = {}) => {
  return requestPDServer('/platform/chat/dialogs/by-pairs', data, options);
};

/**
 * 获取邮件列表
 * 参数: {"type":"inbox/all","offset":0,"limit":15,"femaleIds":[69593048],"idRegularUser":""}
 * type: 取值1、inbox/all、inbox/unread、inbox/unanswered（分别对应Inbox中的All、Unread、Unanswered）,2、has_limits（对应Active limits），3、starred(对应Starred)，4、vip(对应VIP)，5、outbox(对应Outbox)，6、trash(对应Trash)
 * offset: 分页依据，初值为0，每次加上limit
 * femaleIds: 当前用户id（可能可选多值，未测试）
 * idRegularUser: 为空值或者数字；为空值就是默认查询列表，为数字就是根据好友id查询，据测试不支持部分匹配，也就是说只能输入完整id
 */
export const getConnectionsMails = (data) => {
  return requestPDServer('/platform/connections/mails', data);
};
// platform/correspondence/email/star 收藏
// {"id":2857580934} mails.correspondence.last.id
// platform/correspondence/unstar 取消收藏
// {"id":2857580934} mails.correspondence.last.id_correspondence
// type: star/unstar
export const changeEmailStar = (type, id) => {
  const url =
    type === 'star'
      ? '/platform/correspondence/email/star'
      : '/platform/correspondence/unstar';
  return requestPDServer(url, { id });
};

// platform/connections/update // 标为未读true，已读false
// {"idUser":30339782,"update":{"correspondence.hasNew":true}}
export const updateEmailHasNew = (data) => {
  return requestPDServer('/platform/connections/update', data);
};

// 请求邮件列表xhr形式
export async function getConnectionsMailsByXHR(
  token,
  params,
  resultsArray = null,
  backParams = {}
) {
  setCookie();
  return sendXHRRequest(
    '/platform/connections/mails',
    params,
    token,
    resultsArray,
    backParams
  );
}
/**
 * 获取邮件信息
 * 参数: {"page":1,"limit":10,"id_correspondence":2965674419,"id_interlocutor":104474193,"id_user":69593048}
 * page: 页号（每次加1），limit为每页多少条
 * id_correspondence: 邮箱id；
 * id_interlocutor为好友id；
 * id_user为当前用户id；这三个id分别来自邮件列表响应体中的mails[i].id/idRegularUser/idTrustedUser
 * 据测试id_correspondence可以随便填，只要是十位非0开头的数字即可
 */
export const getCorrespondenceEmailsHistory = (data) => {
  return requestPDServer('/platform/correspondence/emails-history', data);
};

// {"idLastMessage":42734549718,"idRegularUser":104474193,"limit":15}
// 响应体为messages数组，message按时间增序排列，不包含idLastMessage对应的那条消息
// idLastMessage为分页依据，初始值可来源于聊天列表返回响应体中diologs[i]的lastmessage.id，也可以是查找好友返回响应体中的idInterlocutorLastReadMsg字段或者lastMessage.id字段
// 后续值来自于上一页返回的信息messages第一条数据的id，即messages[0].id(实现向上翻找数据)
// 初始值建议设置为0，是0的话返回结果就包含最后一条消息
// 响应体messages[].type: likephoto(喜欢某照片)/message（文本信息）/photo_batch（发送照片）/audio(音频)/sticker（表情包）
export const getChatMessages = async (data, options = {}) => {
  // 获取聊天消息
  const messagesResponse = await requestPDServer(
    '/platform/chat/messages',
    data,
    options
  );

  // 如果消息列表为空，直接返回
  if (!messagesResponse.messages || messagesResponse.messages.length === 0) {
    return messagesResponse;
  }

  // 提取所有消息的ID
  const messageIds = messagesResponse.messages.map((msg) => msg.id);

  // 提取音频消息的ID
  const audioIds = messagesResponse.messages
    .filter((msg) => msg.type === 'audio' && msg.content && msg.content.id)
    .map((msg) => msg.content.id);

  // 提取视频消息的ID
  const videoIds = messagesResponse.messages
    .filter((msg) => msg.type === 'video' && msg.content && msg.content.id)
    .map((msg) => msg.content.id);

  // 提取图片消息的ID
  const photoIds = messagesResponse.messages
    .filter(
      (msg) => msg.type === 'photo_batch' && msg.content && msg.content.images
    )
    .flatMap((msg) => msg.content.images.map((img) => img.id));

  // 先返回消息列表，不等待收藏状态和媒体状态
  const messagesWithDefaultFlags = messagesResponse.messages.map((msg) => ({
    ...msg,
    isPinned: false, // 默认设置为未收藏
    isAudioViewed: false, // 默认设置为音频未查看
    isVideoViewed: false, // 默认设置为视频未查看
    isPhotoViewed: false, // 默认设置为图片未查看
  }));

  // 异步获取收藏状态，不阻塞消息显示
  getPinnedMessagesByIds({ ids: messageIds })
    .then((pinnedResponse) => {
      // 创建收藏消息ID的Set，用于快速查找
      const pinnedIdsSet = new Set(
        pinnedResponse ? pinnedResponse.map((id) => Number(id)) : []
      );

      // 更新消息的收藏状态
      messagesWithDefaultFlags.forEach((msg) => {
        const msgId = Number(msg.id);
        // 使用 Vue.set 确保响应式更新
        if (msg.isPinned !== pinnedIdsSet.has(msgId)) {
          msg.isPinned = pinnedIdsSet.has(msgId);
        }
      });
    })
    .catch((error) => {
      console.warn('获取收藏状态失败:', error);
    });

  // 如果有音频消息，异步获取音频查看状态
  if (audioIds.length > 0) {
    const casualData = {
      idUser: data.idRegularUser, // 聊天对象ID
      idsAudios: audioIds,
    };

    getCasualAudioList(casualData)
      .then((casualResponse) => {
        // 创建音频查看状态的映射表
        const casualMap = {};
        if (
          casualResponse &&
          casualResponse.data &&
          casualResponse.data.audios &&
          Array.isArray(casualResponse.data.audios)
        ) {
          casualResponse.data.audios.forEach((item) => {
            if (item.idAudio) {
              casualMap[item.idAudio] = item.status;
            }
          });
        }
        console.log('是否听过音频:', casualMap);
        // 更新音频消息的查看状态
        messagesWithDefaultFlags.forEach((msg) => {
          if (msg.type === 'audio' && msg.content && msg.content.id) {
            const audioId = Number(msg.content.id);
            const isViewed = casualMap[audioId] == 'accessed';
            if (msg.isAudioViewed !== isViewed) {
              msg.isAudioViewed = isViewed;
            }
          }
        });
      })
      .catch((error) => {
        console.warn('获取音频查看状态失败:', error);
      });
  }

  // 如果有视频消息，异步获取视频查看状态
  if (videoIds.length > 0) {
    const casualData = {
      idUser: data.idRegularUser, // 聊天对象ID
      idsVideos: videoIds,
    };

    getCasualVideoList(casualData)
      .then((casualResponse) => {
        // 创建视频查看状态的映射表
        const casualMap = {};
        if (
          casualResponse &&
          casualResponse.videos &&
          Array.isArray(casualResponse.videos)
        ) {
          casualResponse.videos.forEach((item) => {
            if (item.idVideo) {
              casualMap[item.idVideo] = item.status;
            }
          });
        }
        console.log('是否看过视频:', casualMap);
        // 更新视频消息的查看状态
        messagesWithDefaultFlags.forEach((msg) => {
          if (msg.type === 'video' && msg.content && msg.content.id) {
            const videoId = Number(msg.content.id);
            const isViewed = casualMap[videoId] == 'accessed';
            if (msg.isVideoViewed !== isViewed) {
              msg.isVideoViewed = isViewed;
            }
          }
        });
      })
      .catch((error) => {
        console.warn('获取视频查看状态失败:', error);
      });
  }

  // 如果有图片消息，异步获取图片查看状态
  if (photoIds.length > 0) {
    const casualData = {
      idUser: data.idRegularUser, // 聊天对象ID
      idsPhotos: photoIds,
    };

    getCasualPhotoList(casualData)
      .then((casualResponse) => {
        // 创建图片查看状态的映射表
        const casualMap = {};
        if (
          casualResponse &&
          casualResponse.photos &&
          Array.isArray(casualResponse.photos)
        ) {
          casualResponse.photos.forEach((item) => {
            if (item.idPhoto) {
              casualMap[item.idPhoto] = item.status;
            }
          });
        }
        console.log('是否看过图片:', casualMap);
        // 更新图片消息的查看状态
        messagesWithDefaultFlags.forEach((msg) => {
          if (msg.type === 'photo_batch' && msg.content && msg.content.images) {
            // 检查该消息中的所有图片是否都已查看
            const allPhotosViewed = msg.content.images.every((img) => {
              const photoId = Number(img.id);
              return casualMap[photoId] == 'accessed';
            });
            if (msg.isPhotoViewed !== allPhotosViewed) {
              msg.isPhotoViewed = allPhotosViewed;
            }
          }
        });
      })
      .catch((error) => {
        console.warn('获取图片查看状态失败:', error);
      });
  }

  // 立即返回消息列表
  return {
    ...messagesResponse,
    messages: messagesWithDefaultFlags,
  };
};

// 获取收藏的消息列表
// platform/chat/messages/pinned
// {"idRegularUser":104474193,"idLastMessage":null,"limit":15}
export const getPinnedMessages = (data) => {
  return requestPDServer('/platform/chat/messages/pinned', data).then(
    (response) => {
      // 为所有消息添加 isPinned: true 属性
      if (response && response.messages) {
        response.messages = response.messages.map((message) => ({
          ...message,
          isPinned: true,
        }));
      }
      return response;
    }
  );
};

// https://i.gstatvb.com/upload.php?app=shpzkl&sign=549a3e56
// 返回：{
// "key": "shpzkl2ccncp30vhv",//用于上传文件到后台的请求体中，可以理解未临时id
// "size": "474x474",
// "full_size": "https://i.gstatvb.com/shpzkl2ccncp30vhv.57d3c016.jpg",
// "uploaded_before": false
// }
export const uploadImage = (formData) => {
  return new Promise((resolve, reject) => {
    setCookie();
    return fetch(`https://i.gstatvb.com/upload.php?app=shpzkl&sign=549a3e56`, {
      method: 'POST',
      body: formData, // 直接使用FormData，不设置Content-Type让浏览器自动设置
    })
      .then((response) => {
        console.log('uploadImage response status:', response.status);
        console.log('uploadImage response headers:', response.headers);
        return handleFetchResponse(response, resolve, reject);
      })
      .catch((err) => {
        console.error('uploadImage fetch error:', err);
        reject(err);
      });
  });
};
// 上传文件 data.key: 文件key
// {
//   "idPhoto": 49252018,
//   "urls": {
//     "urlOriginal": "https://i.gstatvb.com/shpzkl6p5nldeuql0.80902cf7.jpg",
//     "urlPreview": "https://i.gstatvb.com/shpzkl6p5nldeuql0.r170x170.e6a7f5d4.jpg",
//     "urlStandard": "https://i.gstatvb.com/shpzkl6p5nldeuql0.r800x800.f.d7d9c009.jpg"
//   }
// }
export const getUploadImage = (data) => {
  return requestPDServer('/platform/gallery/photo/upload', data);
};

// 上传视频
// 返回：
// {
//   "idVideo": 8060337,
//   "uploadParams": {
//       "inputs": {
//           "key": "69593048/${filename}",
//           "acl": "private",
//           "Content-Type": "",
//           "success_action_status": "201",
//           "x-amz-meta-id_user": 69593048,
//           "x-amz-meta-service": "gallery",
//           "x-amz-meta-id_entity": "8060337",
//           "x-amz-meta-type": "video",
//           "x-amz-meta-env-domain": "prod",
//           "X-Amz-Credential": "AKIAUP4U5UUQD6UFVGAT/20250714/us-east-1/s3/aws4_request",
//           "X-Amz-Algorithm": "AWS4-HMAC-SHA256",
//           "X-Amz-Date": "20250714T121316Z",
//           "Policy": "eyJleHBpcmF0aW9uIjoiMjAyNS0wNy0xNFQyMDoxMzoxNloiLCJjb25kaXRpb25zIjpbeyJhY2wiOiJwcml2YXRlIn0seyJidWNrZXQiOiJ2Yi12aWRlby1pbnB1dCJ9LFsic3RhcnRzLXdpdGgiLCIka2V5IiwiNjk1OTMwNDhcLyJdLFsic3RhcnRzLXdpdGgiLCIkQ29udGVudC1UeXBlIiwidmlkZW9cLyJdLFsiY29udGVudC1sZW5ndGgtcmFuZ2UiLDAsNTM2ODcwOTEyXSx7InN1Y2Nlc3NfYWN0aW9uX3N0YXR1cyI6IjIwMSJ9LFsic3RhcnRzLXdpdGgiLCIkeC1hbXotbWV0YS1pZF9taXJyb3JzIiwibSJdLFsiZXEiLCIkeC1hbXotbWV0YS1pZF91c2VyIiw2OTU5MzA0OF0sWyJlcSIsIiR4LWFtei1tZXRhLWlkX2VudGl0eSIsIjgwNjAzMzciXSxbImVxIiwiJHgtYW16LW1ldGEtdHlwZSIsInZpZGVvIl0sWyJlcSIsIiR4LWFtei1tZXRhLWVudi1kb21haW4iLCJwcm9kIl0seyJYLUFtei1EYXRlIjoiMjAyNTA3MTRUMTIxMzE2WiJ9LHsiWC1BbXotQ3JlZGVudGlhbCI6IkFLSUFVUDRVNVVVUUQ2VUZWR0FUXC8yMDI1MDcxNFwvdXMtZWFzdC0xXC9zM1wvYXdzNF9yZXF1ZXN0In0seyJYLUFtei1BbGdvcml0aG0iOiJBV1M0LUhNQUMtU0hBMjU2In1dfQ==",
//           "X-Amz-Signature": "9742fd63a7af8a2ca75d4ad5012f0eb74ae79b30985530f221e595a73edc3fb9"
//       },
//       "form": {
//           "action": "https://vb-video-input.s3.amazonaws.com",
//           "method": "POST",
//           "enctype": "multipart/form-data"
//       }
//   }
// }
export const getUploadVideoForm = (formData) => {
  return requestPDServer('/platform/gallery/video/upload', formData);
};
// 上传视频
// key
// 69593048/${filename}
// acl
// private
// Content-Type
// video/mp4
// success_action_status
// 201
// x-amz-meta-id_user
// 69593048
// x-amz-meta-service
// gallery
// x-amz-meta-id_entity
// 8060337
// x-amz-meta-type
// video
// x-amz-meta-env-domain
// prod
// X-Amz-Credential
// AKIAUP4U5UUQD6UFVGAT/20250714/us-east-1/s3/aws4_request
// X-Amz-Algorithm
// AWS4-HMAC-SHA256
// X-Amz-Date
// 20250714T121316Z
// Policy
// eyJleHBpcmF0aW9uIjoiMjAyNS0wNy0xNFQyMDoxMzoxNloiLCJjb25kaXRpb25zIjpbeyJhY2wiOiJwcml2YXRlIn0seyJidWNrZXQiOiJ2Yi12aWRlby1pbnB1dCJ9LFsic3RhcnRzLXdpdGgiLCIka2V5IiwiNjk1OTMwNDhcLyJdLFsic3RhcnRzLXdpdGgiLCIkQ29udGVudC1UeXBlIiwidmlkZW9cLyJdLFsiY29udGVudC1sZW5ndGgtcmFuZ2UiLDAsNTM2ODcwOTEyXSx7InN1Y2Nlc3NfYWN0aW9uX3N0YXR1cyI6IjIwMSJ9LFsic3RhcnRzLXdpdGgiLCIkeC1hbXotbWV0YS1pZF9taXJyb3JzIiwibSJdLFsiZXEiLCIkeC1hbXotbWV0YS1pZF91c2VyIiw2OTU5MzA0OF0sWyJlcSIsIiR4LWFtei1tZXRhLWlkX2VudGl0eSIsIjgwNjAzMzciXSxbImVxIiwiJHgtYW16LW1ldGEtdHlwZSIsInZpZGVvIl0sWyJlcSIsIiR4LWFtei1tZXRhLWVudi1kb21haW4iLCJwcm9kIl0seyJYLUFtei1EYXRlIjoiMjAyNTA3MTRUMTIxMzE2WiJ9LHsiWC1BbXotQ3JlZGVudGlhbCI6IkFLSUFVUDRVNVVVUUQ2VUZWR0FUXC8yMDI1MDcxNFwvdXMtZWFzdC0xXC9zM1wvYXdzNF9yZXF1ZXN0In0seyJYLUFtei1BbGdvcml0aG0iOiJBV1M0LUhNQUMtU0hBMjU2In1dfQ==
// X-Amz-Signature
// 9742fd63a7af8a2ca75d4ad5012f0eb74ae79b30985530f221e595a73edc3fb9
// x-amz-meta-id_mirrors
// m
// file
// (二进制)
export const uploadVideo = (formData) => {
  return new Promise((resolve, reject) => {
    setCookie();
    getUploadVideoForm({
      tags: [],
    })
      .then((form) => {
        console.log('获取到的上传表单:', form);

        // 使用获取到的表单参数上传到S3
        const uploadFormData = new FormData();

        // 添加所有必要的参数
        Object.keys(form.uploadParams.inputs).forEach((key) => {
          // 如果是Content-Type且值为空，则用file.type覆盖
          if (key === 'Content-Type') {
            const file = formData.get('file');
            const contentType = file && file.type ? file.type : 'video/mp4';
            uploadFormData.append('Content-Type', contentType);
            console.log(`修正Content-Type: ${contentType}`);
          } else {
            uploadFormData.append(key, form.uploadParams.inputs[key]);
            console.log(`添加参数: ${key} = ${form.uploadParams.inputs[key]}`);
          }
        });

        // 强制覆盖 x-amz-meta-id_mirrors
        uploadFormData.set('x-amz-meta-id_mirrors', 'm');
        console.log('强制设置x-amz-meta-id_mirrors为空字符串');

        // 添加文件，并确保设置正确的Content-Type
        const file = formData.get('file');
        if (file) {
          console.log('文件信息:', {
            name: file.name,
            type: file.type,
            size: file.size,
          });

          // 确保文件是视频类型
          if (!file.type.startsWith('video/')) {
            reject(new Error('文件必须是视频类型'));
            return;
          }

          // 将文件添加到FormData，让浏览器自动设置正确的Content-Type
          uploadFormData.append('file', file);
          console.log('文件已添加到FormData，Content-Type将自动设置');
        }

        console.log('准备上传到:', form.uploadParams.form.action);
        console.log('上传方法:', form.uploadParams.form.method);

        // 调试：打印FormData的内容
        console.log('FormData内容:');
        for (let [key, value] of uploadFormData.entries()) {
          if (key === 'file') {
            console.log(
              `${key}: ${value.name} (${value.type}, ${value.size} bytes)`
            );
          } else {
            console.log(`${key}: ${value}`);
          }
        }

        // 上传到S3
        return fetch(form.uploadParams.form.action, {
          method: form.uploadParams.form.method,
          body: uploadFormData,
        })
          .then((response) => {
            console.log('上传响应状态:', response.status);
            if (response.status === 201) {
              resolve({
                success: true,
                message: '视频上传成功',
              });
            } else {
              // 尝试读取错误信息
              return response.text().then((errorText) => {
                console.error('上传失败响应:', errorText);
                reject(new Error('视频上传失败: ' + errorText));
              });
            }
          })
          .catch((err) => {
            console.error('上传请求失败:', err);
            reject(err);
          });
      })
      .catch((err) => {
        console.error('获取上传表单失败:', err);
        reject(err);
      });
  });
};

// 保存媒体库信息（音频上传第一步）
// /platform/upload/save-mail-media-gallery
// 参数: {"idUser":35584915,"media":[{"title":"123223232.mp3"}],"type":"audio"}
// 返回: {"data":{"status":"success","media":[{"id":752287,...}]}}
export const saveMailMediaGallery = (data) => {
  return requestPDServer('/platform/upload/save-mail-media-gallery', data);
};

// 获取音频上传参数（音频上传第二步）
// /platform/upload/audio-upload-params
// 参数: {"idUser":35584915,"idAudio":752287}
// 返回: {"data":{"uploadParams":{...}}}
export const getAudioUploadParams = (data) => {
  return requestPDServer('/platform/upload/audio-upload-params', data);
};

// 上传音频
// formData: 包含 file 和 idUser 的 FormData
export const uploadAudio = (formData, idUser) => {
  return new Promise((resolve, reject) => {
    setCookie();
    const file = formData.get('file');
    if (!file) {
      reject(new Error('文件不能为空'));
      return;
    }

    // 第一步：保存媒体库信息
    saveMailMediaGallery({
      idUser: idUser,
      media: [{ title: file.name }],
      type: 'audio'
    })
      .then((response) => {
        console.log('保存媒体库信息响应:', response);
        
        if (!response.data || !response.data.media || response.data.media.length === 0) {
          reject(new Error('保存媒体库信息失败，未获取到媒体ID'));
          return;
        }

        const idAudio = response.data.media[0].id;
        console.log('获取到的音频ID:', idAudio);

        // 第二步：获取上传参数
        return getAudioUploadParams({
          idUser: idUser,
          idAudio: idAudio
        });
      })
      .then((paramsResponse) => {
        console.log('获取上传参数响应:', paramsResponse);
        
        if (!paramsResponse.data || !paramsResponse.data.uploadParams) {
          reject(new Error('获取上传参数失败'));
          return;
        }

        const uploadParams = paramsResponse.data.uploadParams;
        const file = formData.get('file');

        // 第三步：构建上传到S3的FormData
        const uploadFormData = new FormData();

        // 添加所有必要的参数
        Object.keys(uploadParams.inputs).forEach((key) => {
          // 如果是Content-Type且值为空，则用file.type覆盖
          if (key === 'Content-Type') {
            const contentType = file && file.type ? file.type : 'audio/mpeg';
            uploadFormData.append('Content-Type', contentType);
            console.log(`修正Content-Type: ${contentType}`);
          } else {
            uploadFormData.append(key, uploadParams.inputs[key]);
            console.log(`添加参数: ${key} = ${uploadParams.inputs[key]}`);
          }
        });

        // 强制覆盖 x-amz-meta-id_mirrors
        uploadFormData.set('x-amz-meta-id_mirrors', 'm');
        console.log('强制设置x-amz-meta-id_mirrors为m');

        // 添加文件
        if (file) {
          console.log('文件信息:', {
            name: file.name,
            type: file.type,
            size: file.size,
          });

          // 确保文件是音频类型
          if (!file.type.startsWith('audio/')) {
            reject(new Error('文件必须是音频类型'));
            return;
          }

          uploadFormData.append('file', file);
          console.log('文件已添加到FormData');
        }

        console.log('准备上传到:', uploadParams.form.action);
        console.log('上传方法:', uploadParams.form.method);

        // 上传到S3
        return fetch(uploadParams.form.action, {
          method: uploadParams.form.method,
          body: uploadFormData,
        })
          .then((response) => {
            console.log('上传响应状态:', response.status);
            if (response.status === 201) {
              resolve({
                success: true,
                message: '音频上传成功',
              });
            } else {
              // 尝试读取错误信息
              return response.text().then((errorText) => {
                console.error('上传失败响应:', errorText);
                reject(new Error('音频上传失败: ' + errorText));
              });
            }
          })
          .catch((err) => {
            console.error('上传请求失败:', err);
            reject(err);
          });
      })
      .catch((err) => {
        console.error('音频上传流程失败:', err);
        reject(err);
      });
  });
};

// 重新审核
// /platform/gallery/photo/send-for-moderation
export const sendForModeration = (data) => {
  return requestPDServer('/platform/gallery/photo/send-for-moderation', data);
};
// 更新音频名称
// idAudio:324771
// title:"rick111.mp3"
// https://talkytimes.com/platform/gallery/audio/update
export const updateAudioName = (data) => {
  return requestPDServer('/platform/gallery/audio/update', data);
};

// 发送邮件
// 参数：{
// "idUserTo":104474193,
// "content":"I still remember the first time I met you, with a gentle breeze blowing and your hair fluttering in the wind. At that moment, my world seemed to be at a standstill. Since then, every move you make has touched my heart. Your laughter when you are happy, as clear as a silver bell, can dispel all the gloom in my heart; When you are sad, I wish I could bear all the sadness for you. I want to be your safe haven in life, no matter how strong the wind and rain, I can make you rely on it with peace of mind. In these long years, I am willing to love you with all my heart, accompany you through every spring, summer, autumn, and winter, and witness every wonderful moment in your life.",
// "images":[{"idPhoto":50934234},{"idPhoto":50934233}],
// "videos":[],
// "vip":true
// }
// 返回
// {"data":{"status":"success","details":[]}}
export const sendLetter = (data) => {
  if (data && data.videos && Array.isArray(data.videos)) {
    data.videos = data.videos.map((video) => {
      if (video.idVideo) {
        video.idVideo = Number(video.idVideo);
      }
      return video;
    });
  }
  return requestPDServer('/platform/correspondence/send-letter', data);
};
// 收藏消息
// /platform/chat/message/pin
// idMessage: 42882118885
export const pinMessage = (data) => {
  return requestPDServer('/platform/chat/message/pin', data);
};
// 取消收藏消息
// /platform/chat/message/unpin
// idMessage: 42882118885
export const unpinMessage = (data) => {
  return requestPDServer('/platform/chat/message/unpin', data);
};
/**
 * 获取用户VIP状态（限制15个用户）
 * @param {Array} data - 用户ID数组，idsUsers中的id都是数字格式
 * @returns {Promise} 返回用户VIP状态
 *
 * 接口地址：https://talkytimes.com/platform/contact-list/list-by-users
 * 请求参数：{"idsUsers":[104474193,30339782,75471893,...], "names":["vip","unmanaged_vip"]}
 */
export const getUserIsVip15 = (data) => {
  // 将ID转换为数字格式
  const idsUsers = Array.isArray(data) ? data.map((id) => Number(id)) : [];

  return requestPDServer('/platform/contact-list/list-by-users', {
    idsUsers: idsUsers,
    names: ['vip', 'unmanaged_vip'],
  }).then((res) => {
    // 统一处理数据格式
    const result = {};
    if (res && Array.isArray(res)) {
      res.forEach((item) => {
        if (item && item.idUser && Array.isArray(item.names)) {
          result[item.idUser] = {
            isVip: item.names.includes('vip'),
            isUnmanagedVip: item.names.includes('unmanaged_vip'),
          };
        } else if (item && item.idUser) {
          result[item.idUser] = {
            isVip: false,
            isUnmanagedVip: false,
          };
        }
      });
    }
    return result;
  });
};

/**
 * 分批查询用户VIP状态 - 支持大量用户查询
 * @param {Array} data - 用户ID数组，idsUsers中的id都是数字格式
 * @param {number} batchSize - 每批查询的用户数量，默认15
 * @returns {Promise} 返回所有用户的VIP状态
 */
export const getUserIsVip = (data, batchSize = 15) => {
  // 确保 data 是数组
  const idsUsers = Array.isArray(data) ? data : [];

  if (idsUsers.length === 0) {
    return Promise.resolve({});
  }

  // 如果用户数量不超过批次大小，直接调用原方法
  if (idsUsers.length <= batchSize) {
    return getUserIsVip15(idsUsers);
  }

  // 分批处理
  const batches = chunkArray(idsUsers, batchSize);

  console.log(
    `开始分批查询VIP状态，总共 ${idsUsers.length} 个用户，分为 ${batches.length} 批`
  );

  // 并发查询所有批次，每个请求都有独立的错误处理
  const promises = batches.map((batch, index) => {
    console.log(`查询VIP第 ${index + 1} 批，包含 ${batch.length} 个用户`);
    return getUserIsVip15(batch)
      .then((res) => {
        console.log(`VIP第 ${index + 1} 批查询完成：`, res);
        return res;
      })
      .catch((error) => {
        // 单个批次失败时立即处理错误
        console.error(`VIP第 ${index + 1} 批查询失败：`, error);
        // 返回空对象，让其他批次继续执行
        return {};
      });
  });

  return Promise.all(promises).then((results) => {
    // 合并所有批次的结果
    const allResults = {};
    results.forEach((result) => {
      if (result && typeof result === 'object') {
        Object.assign(allResults, result);
      }
    });

    console.log('所有VIP状态查询完成：', allResults);
    return allResults;
  });
};

/**
 * 数组分批工具方法（用于VIP查询）
 * @param {Array} array - 要分批的数组
 * @param {number} size - 每批的大小
 * @returns {Array} 分批后的二维数组
 */
const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

// 获取邮箱的id
// https://talkytimes.com/platform/correspondence/get
// {"idInterlocutor":104474193}
export const getEmailId = (data, options = {}) => {
  return requestPDServer('/platform/correspondence/get', data, options);
};
//
// 获取是否可以设置vip
// https://talkytimes.com/platform/feature-flag/list
// {"idRegularUser":104474193}
export const getFeatureFlagList = (options = {}) => {
  return requestPDServer('/platform/feature-flag/list', {}, options);
};

function setCookie() {
  const activeUser = localStorage.getItem('activeUser');
  if (activeUser) {
    const user = JSON.parse(activeUser);
    Cookies.set('tld-token', user.pdToken);
  }
}

// 阅读消息（用户对话）
// https://talkytimes.com/platform/chat/read
// idRegularUser: 104474193
export const readChat = (data, options = {}) => {
  return requestPDServer('/platform/chat/read', data, options);
};
// 阅读消息（一条消息）
// https://talkytimes.com/platform/correspondence/read
// idMessage: 42882118885
export const readMessage = (data) => {
  return requestPDServer('/platform/chat/message/read', data);
};

// 获取用户是否查看过照片
// https://talkytimes.com/platform/gallery/photo/connection/casual-list
/**
 * {
 *  idUser: 104474193,
 *  idsPhotos: [104474193,104474193],
 * }
 * */
export const getCasualPhotoList = (data) => {
  return requestPDServer('/platform/gallery/photo/connection/list', data);
};

// 获取用户是否发送过视频send、对方用户是否查看过视频accessed
// https://talkytimes.com/platform/gallery/video/connection/list
/**
 * {
 *  idUser: 104474193,
 *  idsVideos: [104474193,104474193],
 * }
 * */
export const getCasualVideoList = (data) => {
  return requestPDServer('/platform/gallery/video/connection/list', data);
};
// https://talkytimes.com/platform/gallery/audio/connection/list
//参数：{"idUser":30339782,"idsAudios":[324771,324770,324769,324768,324767,324766,324765,324764,324763,324761,323923,323922,323846,323845,312615]}
// 返回：
// {
//   "data": {
//       "audios": [
//           {
//               "idAudio": 324771,
//               "status": "accessed"
//           },
//           {
//               "idAudio": 324770,
//               "status": "accessed"
//           }
//       ]
//   }
// }
export const getCasualAudioList = (data) => {
  return requestPDServer('/platform/gallery/audio/connection/list', data);
};

// 获取用户是否可以请求聊天(男用户专属)
// platform/chat/dialogs/request-limit/users-info
// idsRegularUsers: [104474193,104474193],
export const getRequestLimitUsersInfo = (data) => {
  return requestPDServer(
    '/platform/chat/dialogs/request-limit/users-info',
    data
  );
};

// 是否可以发送礼物
// /platform/present/real/present/is-available
// {"idRegularUser":104474193}
// 返回
// {
//   "isAvailable": true
// }
export const getPresentIsAvailable = (data, options = {}) => {
  return requestPDServer('/platform/present/real/present/is-available', data, options);
};
// 列表消息是否被收藏的接口
// https://talkytimes.com/platform/chat/messages/pinned/by-ids
// {"ids":[42882118885,42882118885]}
export const getPinnedMessagesByIds = (data) => {
  return requestPDServer('/platform/chat/messages/pinned/by-ids', data);
};
// 发送礼物，弹窗显示
// platform/virtual-gift/send
// {"idUserTo":111741523,"idGift":58,"message":"I hope my wife truly loves me. I don't like her responsibilities and I want to live happily with her"}
export const sendVirtualGift = (data) => {
  return requestPDServer('/platform/virtual-gift/send', data);
};
// 预览某张照片（的清晰版本）
// https://talkytimes.com/platform/operator/get-photo/129551208?preview=https://i.gstatvb.com/shpzkl3fuqqqbfrnl.r300x300.4967780d.jpg
// {"idPhoto":129551208,"preview":"https://i.gstatvb.com/shpzkl3fuqqqbfrnl.r300x300.4967780d.jpg"}
export const getPhotoPreview = (data) => {
  return requestPDServer(
    '/platform/operator/get-photo/' + data.idPhoto + '?preview=' + data.preview,
    {}
  );
};

/**
 * 获取连接照片列表（非PD接口）
 * 参数: {
 *   idInterlocutor: 目标用户ID,
 *   limit: 查询数量限制,
 *   statuses: 状态列表,
 *   tags: 标签列表,
 *   excludeTags: 排除的标签列表,
 *   excludeConnectionStatuses: 排除的连接状态列表
 * }
 */
export const getConnectionPhotos = async (data) => {
  // 直接请求后端：POST /listConnectionPhotos（如：http://127.0.0.1:19002/listConnectionPhotos）
  // 禁用加密，直接发送JSON数据
  return request({
    url: '/listConnectionPhotos',
    method: 'post',
    data,
    headers: {
      isEncrypt: false
    }
  });
};

export const getConnectionVideos = async (data) => {
  // 直接请求后端：POST /listConnectionVideos（如：http://127.0.0.1:19002/listConnectionVideos）
  // 禁用加密，直接发送JSON数据
  return request({
    url: '/listConnectionVideos',
    method: 'post',
    data,
    headers: {
      isEncrypt: false
    }
  });
};

export const getConnectionAudios = async (data) => {
  // 直接请求后端：POST /listConnectionAudios（如：http://127.0.0.1:19002/listConnectionAudios）
  // 禁用加密，直接发送JSON数据
  return request({
    url: '/listConnectionAudios',
    method: 'post',
    data,
    headers: {
      isEncrypt: false
    }
  });
};
